module.exports = __webpack_public_path__ + "media/charts-diagrams.772a2b6279a029e089ccac37d60ca8a3.svg";